/**
 * @author Sirisha.M
 * @description 
 */
import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { config } from '../../constant';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const CandleStick = (props) => {
  const [option, setOption] = useState({});
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
    translationCache
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData();
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    translationCache
  ]);

  const getData = async () => {
    let option = getOption();
    requestCheck.current = false;
    let json = [];
    let { graphprops } = props;
    let errorInAPI = false;
    let noDataInDB = false;
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      let tagnames = [];
      let name = '';
      json.map((val) => {
        if (val.Name !== name) {
          if (tagnames.indexOf(val.Name) === -1) {
            tagnames.push(val.Name);
          }
        }
        return {};
      });
      let values = [];
      let dates = [];
      let seriesarray = [];
      tagnames.map((tagval, tagindex) => {
        values = [];
        json.map((jsonval) => {
          if (tagnames[0] === jsonval.Name && tagindex === 0) {
            let date =
              graphprops && graphprops.type === 'live'
                ? moment
                  .utc(jsonval.DateTime)
                  .tz(currentTimeZone)
                  .format('DD/MM/YYYY HH:mm:ss')
                : moment(jsonval.DateTime).format('DD/MM/YYYY HH:mm:ss');
            dates.push(date);
          }
          if (tagval === jsonval.Name) {
            values.push(jsonval.Value);
          }
          return {};
        });
        seriesarray.push(values);
        return {};
      });
      option = {
        ...option,
        xAxis: {
          data: dates || [],
          axisLine: {
            lineStyle: {
              color: props.theme.algorithm === "dark" ? 'white' : 'black'
            }
          },
          axisTick: {
            lineStyle: {
              color: props.theme.algorithm === "dark" ? 'white' : 'black'
            }
          },
          axisLabel: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        series: [
          {
            type: 'candlestick',
            data: seriesarray || []
          }
        ]
      };
      setOption(option);
      setRefreshDateTime(moment());
    }
    // }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };
  const getOption = () => {
    let option = {
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        data: [],
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisTick: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisLabel: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black'
        }
      },
      yAxis: {
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        }
      },
      series: [
        {
          type: 'candlestick',
          data: []
        }
      ],
      toolbox: {
        showTitle: false,
        orient: 'vertical',
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: props.theme.algorithm === "dark" ? 'black' : 'white',
            name: graphprops.title
            // backgroundColor: "black",
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,

          backgroundColor: '#9a9191',
          textStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        }
      ]
    };

    return option;
  };

  return (

    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          style={{ height: '90%', width: '100%' }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(CandleStick);
